import React from 'react';
import {Stack, Typography} from '@mui/material';

const SourcesRootDropOverlay = () => (
    <Stack
        data-testid="sources-root-drop-overlay"
        sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 6,
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
            bgcolor: 'rgba(233, 236, 239, 0.32)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            boxShadow: 'inset 0 0 0 2px #1976d2',
            px: 2,
        }}
    >
        <Stack
            sx={{
                bgcolor: 'rgba(25, 118, 210, 0.96)',
                color: 'white',
                borderRadius: 1,
                px: 2,
                py: 1.25,
                textAlign: 'center',
                maxWidth: 340,
                boxShadow: 3,
            }}
        >
            <Typography variant="body2" fontWeight={600}>
                Drop files to upload into My files
            </Typography>
            <Typography variant="caption">
                They will be added to the root folder.
            </Typography>
        </Stack>
    </Stack>
);

export default React.memo(SourcesRootDropOverlay);
